<template>
<v-container class="play-page" fluid style="height:100vh" :class="{'hero' :  !mobile}">
    <div v-if="mobile">

    <v-row>
      <v-col cols="" lg="6" md="6" sm="12" xs="12" class="main-play-page pt-16">

        <div class="d-flex flex-column flex-sm-row align-center justify-center">
          <div class="">
            <img src="./../assets/sww.png"  style="width:100%" />
          </div>
          
        </div>

      </v-col>
      
      <v-col cols="" lg="6" md="6" sm="12" xs="12" v-if="mobile" class="pt-10">
            <v-form ref="form" class="main-form" v-model="valid" lazy-validation @submit="submit()">
                <h4>Verification</h4>
            <p class="mt-4 auth-note" v-if="credentials.mobile">
              Please verify your mobile number by providing the One Time Pin we
              sent to
              <strong>{{ credentials.mobile }}</strong>
            </p>
            <p class="body-2 my-2 white--text">One Time Pin</p>
          <v-text-field
            v-model="credentials.pin"
            label="One Time Pin"
            type="number"
            :rules="[rules.required]"
            :error-messages="error || ''"
            @keypress.enter="submit()"
            required
            background-color="#c0c2ce33"
            solo
            dense
            hide-details="auto"
          ></v-text-field>
          <div class="text-center mt-4">
            <v-btn
              color="#31404b"
              class="mb-6"
              @click="submit()"
              :loading="busy"
              block
            >
              Verify
            </v-btn>
            <p class="mt-5 auth-note mb-1">Didn't recieve your One Time Pin?</p>
            <v-btn
              color="#31404b"
              block
              
              class="mb-0"
              @click.stop="reSend()"
              :loading="busy"
              :disabled="disableResend"
            >
              Resend pin
            </v-btn>
            <br />
            <v-btn v-if="!isModal" color="#fff" outlined block  @click.stop="backToPlay()">Back</v-btn>
          </div>
            </v-form>
        
      </v-col>

    </v-row>

    </div>

    <div v-else>

    <v-row no-gutters class="pt-10">
      <v-col >    
        <div class="d-flex flex-column flex-sm-row align-center justify-center">
        
            <div class="pl-5">
              <img src="./../assets/sww.png" class="login-logo" />
            </div>

            <v-form ref="form" class="main-form" v-model="valid" lazy-validation @submit="submit()">
                <h4>Verification</h4>
            <p class="mt-4 auth-note" v-if="credentials.mobile">
              Please verify your mobile number by providing the One Time Pin we
              sent to
              <strong>{{ credentials.mobile }}</strong>
            </p>
            <p class="body-2 my-2 white--text">One Time Pin</p>
          <v-text-field
            v-model="credentials.pin"
            label="One Time Pin"
            type="number"
            :rules="[rules.required]"
            :error-messages="error || ''"
            @keypress.enter="submit()"
            required
            background-color="#c0c2ce33"
            solo
            dense
            hide-details="auto"
          ></v-text-field>
          <div class="text-center mt-4">
            <v-btn
              color="#31404b"
              class="mb-6"
              @click="submit()"
              :loading="busy"
              block
            >
              Verify
            </v-btn>
            <p class="mt-5 auth-note mb-1">Didn't recieve your One Time Pin?</p>
            <v-btn
              color="#31404b"
              block
              
              class="mb-0"
              @click.stop="reSend()"
              :loading="busy"
              :disabled="disableResend"
            >
              Resend pin
            </v-btn>
            <br />
            <v-btn v-if="!isModal" color="#fff" outlined block  @click.stop="backToPlay()">Back</v-btn>
          </div>
            </v-form>
        </div>
      </v-col>
    </v-row>

    </div>
  </v-container>
</template>

<script>
import mixin from "./../mixins";
import auth from "./../mixins/auth";
import rules from "./../mixins/rules";

export default {
  mixins: [mixin, auth, rules],
  data: () => ({
    valid: true,
    withMobile: true,
    disableResend: false,
    credentials: {
      pin: null,
      mobile: null,
    },
  }),
  computed: {
    isIOS() {
      return window.isIOS;
    },
    mobile() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },

  methods: {
    submit() {
      if (this.$refs.form.validate()) this.verify(this.credentials, this.isModal);
    },
    reRegister() {
      localStorage.removeItem("verified");
      this.$router.push({ name: "login" });
    },
    reSend() {
      this.has_code = true;
      this.disableResend = true;
      this.reSendPin(this.credentials);
      setTimeout(() => {
        this.disableResend = false;
      }, 30000);
    },
    backToPlay() {
                this.$router.push({ name: "play" });
            }
  },
  mounted() {
    this.has_code = false;
    this.$nextTick(() => {
      let registered = localStorage.getItem("user");
      registered
        ? (this.credentials.mobile = JSON.parse(registered).mobile)
        : (this.withMobile = false);
    });
    this.has_code = false;
  },
};
</script>
